__turbopack_context__.v({
  "scroller": "ContentsLinksBar-module__aFvtuW__scroller",
  "tabs": "ContentsLinksBar-module__aFvtuW__tabs",
  "wrapper": "ContentsLinksBar-module__aFvtuW__wrapper",
});
